import React, { forwardRef } from "react";

import { StyledInputWrapper } from "./simpleTextAreaField.style";
import GenericInputField, {
  TYPES,
  Label,
} from "../../../genericInputFields/genericInputField";
import useSolutionForm from "../../../../hooks/useSolutionForm";

const SimpleTextAreaField = forwardRef(({ data, name, error }, ref) => {
  const { id, required, title, placeholder, maxCharacters, restricted } = data;
  const {
    formMethods: { register },
    disableRestrictedFields,
  } = useSolutionForm();

  return (
    <StyledInputWrapper ref={ref}>
      <input
        type="hidden"
        value={id}
        {...register(`${name}.supplemental_submission_field_id`)}
      />
      <Label required={required}>{title}</Label>
      <GenericInputField
        type={TYPES.SIMPLE_TEXTAREA}
        register={register}
        name={`${name}.answer`}
        required={required}
        placeholder={placeholder}
        maxCharacters={maxCharacters}
        readOnly={restricted && disableRestrictedFields}
        error={error}
      />
    </StyledInputWrapper>
  );
});
SimpleTextAreaField.displayName = "SimpleTextAreaField";

export default SimpleTextAreaField;
